import { QueryClient } from '@tanstack/react-query';
import { captureException } from '../utils/monitoring';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: (failureCount, error) => {
        if (failureCount > 3) return false;

        const statusCode = (error as any)?.response?.status;
        if (statusCode === 401 || statusCode === 403 || statusCode === 404) {
          return false;
        }

        return true;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
      onError: (error) => {
        captureException(error as Error, {
          context: 'mutation',
        });
      },
    },
  },
});
